import type { WatchlistItem } from '@/hooks/useWatchlist';
import { useFairValueContext } from '@/pages/Watchlist/components/FairValue/Context';
import { NarrativeFairValue } from '@/components/NarrativeFairValue';

export interface Props {
  watchlistItem: WatchlistItem;
}

export const WatchlistNarrativeFairValue = ({ watchlistItem }: Props) => {
  const { actions } = useFairValueContext();
  const { narrativeFairValue, company } = watchlistItem;

  if (typeof narrativeFairValue !== 'undefined') {
    return (
      <NarrativeFairValue
        currencyISO={company.data.currencyInfo.trading_item_currency_iso}
        narrativeFairValue={narrativeFairValue}
        npvPerShare={company.analysisValue.npvPerShare}
        onClick={() => actions.openFairvalueModal(watchlistItem)}
      />
    );
  }

  return null;
};

export default WatchlistNarrativeFairValue;
